import { StatusCode } from "../../../utils/enums";
import { AxiosResponse } from "axios";
import { ValidacionMutuoResult } from "../models/ValidacionMutuoResult";
import { AprobacionMutuoResult } from "../models/AprobacionMutuoResult";
import { getValidarMutuo, patchAprobarMutuo, getMutuo } from "../services/servicesMutuo";

export interface Mutuo  {
    mutuoId?: number;
    estadoActual: string | null;    
}

export function useMutuo() {
 
    const validarMutuo = async (mutuoId: number): Promise<ValidacionMutuoResult | void> => {

        const resp: AxiosResponse = await getValidarMutuo(mutuoId)
        if (resp.status !== StatusCode.Ok) return;

        const data: ValidacionMutuoResult = await resp.data;

        return data;

    }

    const aprobarMutuo = async (mutuoId: number): Promise<AprobacionMutuoResult | void> => {

        const resp: AxiosResponse = await patchAprobarMutuo(mutuoId)
        if (resp.status !== StatusCode.Ok) return;

        const data: AprobacionMutuoResult = await resp.data;

        return data;

    }

    const obtenerMutuo = async (mutuoId: number): Promise<Mutuo | void> => {

        const resp: AxiosResponse = await getMutuo(mutuoId)
        if (resp.status !== StatusCode.Ok) return;

        const data: Mutuo = await resp.data;

        return data;

    }

    return {
        validarMutuo,
        aprobarMutuo,
        obtenerMutuo
    }
}
